import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DraftService } from '../../services/draft.service';
import { NormalizadorService } from '../../services/normalizador.service';
import { ShoppingCartService } from '../../services/shopping-cart-service';
import { GeneralService } from '../../services/general.service';
import { Router } from '@angular/router';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DigoService } from 'src/app/services/digo.service';

@Component({
    selector: 'app-modal-save',
    templateUrl: './modal-save.component.html',
    styleUrls: ['./modal-save.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class ModalSaveComponent implements OnInit {

    currentDialog = null;
    currentRoute = null;
    orderId = null;
    orderCompleted = null;
    private thereIsNotCoverage: boolean;
    private router: string;
    public classClickedNo: string = '';
    public classClickedYes: string = '';
    public pdv;

    constructor(
        protected modalService: NgbModal,
        protected draftService: DraftService,
        protected normalizadorService: NormalizadorService,
        protected shoppingCartService: ShoppingCartService,
        protected generalService: GeneralService, 
        private _router: Router,
        private matdialog: MatDialog,
        private digoService: DigoService
    ) {
        this.router = _router.url;

        this.draftService.getOrderIdDraft()
            .subscribe(data => {
                this.orderId = data;
            });

        this.draftService.getActivacionCompletada()
            .subscribe(data => {
                this.orderCompleted = data;
            });

        this.normalizadorService.getErrorPeticionCobertura()
            .subscribe((value) => {
                this.thereIsNotCoverage = value;
            });

        this.digoService.getPDV()
            .subscribe(data => {
                if (data) {
                    this.pdv = data;
                }
            });
    }

    ngOnInit(): void {
    }

    onSaveDraft() {
        if (!this.openModalUsuarioDemo()) {
            this.classClickedYes = 'btn-grey-outline2-cliked';
            if (this.router === '/amena/solo_movil' || (!this.thereIsNotCoverage && this.router === '/amena/convergente')) {
                this.generalService.setSaveDataUserInvalid(true);
                this.draftService.saveDraft(true);
            }
            this.draftService.setOrderIdDraft(null);
            this.draftService.orderInit();
            this.modalService.dismissAll();
            this.classClickedYes = '';
            this.draftService.navigateAwaySelection$.next(true);
            this.normalizadorService.setMuestraNormalizacion(true);
            this.normalizadorService.setMuestraBotonNormalizacion(true);
            this.normalizadorService.setFormularioNormalizacion(null);
            this.normalizadorService.setResultadoCobertura(null);
            this.shoppingCartService.clearShoppinCart();
        }
    }

    onRemoveDraft() {
        if (!this.openModalUsuarioDemo()) {
            this.classClickedNo = 'btn-grey-outline2-cliked';
            this.draftService.removeDraft(this.orderId)
                .subscribe(data => {
                    console.log(data);
                    console.log('usuario borrado');
                });

            this.draftService.setOrderIdDraft(null);
            this.draftService.orderInit();
            this.classClickedNo = '';
            this.modalService.dismissAll();
            this.draftService.navigateAwaySelection$.next(true);
            this.normalizadorService.setMuestraNormalizacion(true);
            this.normalizadorService.setMuestraBotonNormalizacion(true);
            this.normalizadorService.setFormularioNormalizacion(null);
            this.normalizadorService.setResultadoCobertura(null);
            this.shoppingCartService.clearShoppinCart();
        }
    }

    closeModal() {
        this.modalService.dismissAll();
        this.draftService.navigateAwaySelection$.next(false);
    }

    openModalUsuarioDemo(): boolean {
        if (this.pdv.permissions.SAMPLE_MODE && this.pdv.permissions.SAMPLE_MODE === 'SAMPLE') {
            this.modalService.dismissAll();
            this.matdialog.open(AlertDialogComponent, {
                data: {message: 'Usuario demostración. No se puede guardar o eliminar un borrador'}
            });
            this.draftService.navigateAwaySelection$.next(true);
            return true;
        }
        return false
    }
}
